import React from 'react';

const ExecutiveItem = (props) => (
    <div id={`practioner--${props.index + 1}`} data-index={`${props.index + 1}`} className="practitioner col-12 padding__16 background__mist margin__bottom">
      <div className="practitioner--index">
        <img src={`/themes/nhs/pins/mapicon_${props.index + 1}.png`} alt={`Practitioner Number ${props.index + 1}`} />
      </div>
      <h2 className="practitioner--title blue heading heading__small">{props.item.title}</h2>
      <dl className="practitioner--dl clearfix">
        <dt>Address :</dt>
        <dd>{props.item.field_address}
        </dd>
        <dt>Doctors &amp; Nurses :</dt>
        <dd>{props.item.body.replace(/<\/?[^>]+(>|$)/g, "")}
        </dd>
        <dt>Contact Details:</dt>
        <dd>
          <i className="fa fa-phone visual-only" role="presentation" aria-hidden="true" />
          {props.item.field_telephone}<span className="spacer">|</span>
          <i className="fa fa-envelope-o visual-only" role="presentation" aria-hidden="true" />
          <a className="navy" href="mailto:ork-HB.LonghopeSurgery@nhs.net" target="_blank">{props.item.field_email}</a>
          <span className="spacer">|</span><i className="fa fa-fax visual-only" role="presentation" aria-hidden="true" />
          {props.item.field_fax}
        </dd>
        <dt>Website:</dt>
        <dd>
          <i className="fa fa-desktop visual-only" role="presentation" aria-hidden="true" />
          <a className="navy" href="http://www.orcadespractice.co.uk/" target="_blank">{props.item.website}</a>
        </dd>
      </dl>
    </div>
);

export default ExecutiveItem;
